import React from 'react';

import { Carousel } from 'antd/es';

import NavTabs from '@app/components/UI/NavTabs/NavTabs';
import dani from '@app/images/content/founder-dani.jpg';
import mary from '@app/images/content/mary-sam-and-duncan-small.jpg';
import '@app/scss/components/foundersBlock.scss';

interface FoundersBlockProps {
	name: string;
	foundersRef?: any;
}

const FoundersBlock: React.FC<FoundersBlockProps> = (props) => {
	const navItems = [
		{
			name: 'second',
			title: 'Dr. Mary Gardner',
		},
		{
			name: 'first',
			title: 'Dr. Dani McVety',
		},
	];

	const foundersInfo = [
		{
			name: 'Dr. Mary Gardner',
			role: 'Co-Founder & CEO',
			description: (
				<>
					There’s nothing Dr. Mary Gardner loves more than a grey-muzzled dog or a wise old cat! As Co-Founder and CEO of Lap of Love, a
					nationwide network of veterinarians dedicated to end-of-life care, she is committed to making final goodbyes as peaceful as
					possible, with compassionate support for both pets and their families.
					<br />
					<br />
					A proud University of Florida graduate, Dr. Gardner is a nationally recognized speaker on geriatric and end-of-life veterinary
					care. Her work focuses on advancing awareness and medical care for aging pets, while educating both veterinary professionals and
					pet parents on how to navigate life's final stages.
					<br />
					<br />
					She is the author of two books:
					{' '}
					<a
						className="inline-block inline-link"
						href="https://www.amazon.com/Its-Never-Long-Enough-practical-ebook/dp/B09PJMVD84"
						target="_blank"
						rel="noopener noreferrer"
					>
						It's Never Long Enough
					</a>
					{' '}
					(for dogs) and
					{' '}
					<a
						className="inline-block inline-link"
						href="https://www.amazon.com/Nine-Lives-Are-Not-Enough/dp/1956343091"
						target="_blank"
						rel="noopener noreferrer"
					>
						Nine Lives Are Not Enough
					</a>
					{' '}
					(for cats), and co-author of
					{' '}
					<a
						className="inline-block inline-link"
						// eslint-disable-next-line max-len
						href="https://www.amazon.com/Forever-Friend-childrens-activity-goodbye/dp/1956343032/ref=asc_df_1956343032?mcid=bd13338be42b306e8e48f2fe2a31f38f&hvocijid=16650979909786193308-1956343032-&hvexpln=73&tag=hyprod-20&linkCode=df0&hvadid=721245378154&hvpos=&hvnetw=g&hvrand=16650979909786193308&hvpone=&hvptwo=&hvqmt=&hvdev=c&hvdvcmdl=&hvlocint=&hvlocphy=9051897&hvtargid=pla-2281435177578&psc=1"
						target="_blank"
						rel="noopener noreferrer"
					>
						Forever Friend
					</a>
					, a series of children’s activity books
					designed to help kids navigate the loss of a beloved dog or cat.
				</>
			),
			img: mary,
			alt: 'Dr. Mary Gardner',
		},
		{
			name: 'Dr. Dani McVety',
			role: 'Founder',
			description: (
				<>
					With a deep love for the human-animal bond, Dr. Dani enjoys just about anything related to animals… and the people who love them!
					Dr. Dani founded Lap of Love Veterinary Hospice and served as CEO until January of 2025, when she stepped down to take more time
					with her family.
					<br />
					<br />
					Dr. McVety frequently writes and speaks to professional and public audiences around the country and internationally, empowering
					all parties to seek and deliver the highest level of care.
					<br />
					<br />
					She proudly graduated from the University of Florida College of Veterinary Medicine and is the youngest recipient of both the
					college’s Distinguished Young Alumni Award (2013) and the Florida Veterinary Medical Association's President's Award (2014). She
					was honored to also receive the Pet Industry Woman of the Year (2017), and is the 2022 AVMA Bustad Companion Animal Veterinarian
					of the Year.
				</>
			),
			img: dani,
			alt: 'Dr. Dani McVety',
		},
	];

	const [currentIndex, setCurrentIndex] = React.useState(0);
	const slider = React.useRef<any>();

	const onSetIssue = (index) => {
		setCurrentIndex(index);
		slider.current.goTo(index);
	};

	return (
		<div className="founders" id={props.name} ref={props.foundersRef!}>
			<div className="founders__wrapper" id="modalMount">
				<div className="founders__body">
					<div className="founders__body-left">
						<h2 className="founders__body-left-title">Our founders</h2>
						<NavTabs
							navItems={navItems}
							currentIndex={currentIndex}
							onSetIssue={onSetIssue}
							navCollapse={undefined}
							onChange={undefined}
						/>
					</div>
					<div className="founders__body-right">
						<Carousel effect="fade" ref={slider} afterChange={setCurrentIndex} dots={false}>
							{foundersInfo.map((item, index) => (
								<div key={index} className="founders__body-right-slide">
									<div className="founders__body-right-slide-vet">
										<div className="founders__body-right-slide-vet-img">
											<img src={item.img} alt={item.alt} />
										</div>
									</div>
									<div className="founders__body-right-slide-descr">
										<div className="founders__body-right-slide-descr-personal">
											<img src={item.img} alt="founder-avatar" />
											<div>
												<h3>{item.name}</h3>
												<h4>{item.role}</h4>
											</div>
										</div>
										<p>{item.description}</p>
									</div>
								</div>
							))}
						</Carousel>
					</div>
				</div>
			</div>
		</div>
	);
};

export default FoundersBlock;
